import { money } from "@/lib/landingSim";

const STATUS = {
  paid: ["Paid in full", "bg-green-100 text-green-700"],
  deposit_paid: ["Deposit received", "bg-blue-100 text-blue-700"],
  unpaid: ["Awaiting payment", "bg-amber-100 text-amber-800"],
};

export const termsLabel = (pct) => (pct >= 100 ? "100% due upfront" : `${pct}% deposit to start, balance on delivery`);

export const InvoiceStatus = ({ status }) => {
  const [l, c] = STATUS[status] || STATUS.unpaid;
  return <span className={`text-[11px] font-bold uppercase px-2 py-0.5 rounded-full ${c}`} data-testid="invoice-status">{l}</span>;
};

export const InvoiceTable = ({ inv }) => (
  <div data-testid="invoice-table">
    <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
      <p className="text-sm text-slate-500">Invoice <b className="text-slate-900" data-testid="invoice-number">{inv.invoice_number}</b> · {termsLabel(inv.deposit_pct)}</p>
      <InvoiceStatus status={inv.status} />
    </div>
    <table className="w-full text-sm">
      <tbody>
        {inv.items.map((i, n) => (
          <tr key={n} className="border-b border-slate-100">
            <td className="py-2 pr-3"><p className="font-medium text-slate-900">{i.label}</p>{i.detail && <p className="text-xs text-slate-400">{i.detail}</p>}</td>
            <td className="py-2 text-right whitespace-nowrap">{money(i.amount)}</td>
          </tr>
        ))}
        <tr className="font-bold"><td className="pt-3">Total</td><td className="pt-3 text-right" data-testid="invoice-total">{money(inv.total)}</td></tr>
        <tr className="text-slate-500"><td>{inv.deposit_pct >= 100 ? "Due upfront" : `Deposit (${inv.deposit_pct}%)`}</td><td className="text-right" data-testid="invoice-deposit">{money(inv.deposit_due)}</td></tr>
        <tr className="text-slate-500"><td>Paid to date</td><td className="text-right" data-testid="invoice-paid">{money(inv.paid)}</td></tr>
        <tr className="font-black text-blue-700 text-base"><td className="pt-1">Balance due</td><td className="pt-1 text-right" data-testid="invoice-balance">{money(inv.balance)}</td></tr>
      </tbody>
    </table>
  </div>
);

export const ShopAdvisorMark = () => (
  <p className="text-center text-[11px] text-slate-400 pt-4 border-t border-slate-100" data-testid="shopadvisor-tm">ShopAdvisor&trade; · theshopadvisor.com</p>
);
